import LottieLoader from "./LottieLoader.vue";

export { LottieLoader };
